<template>

    
    
    <div id="map-selector" >
      <button id=contact aria-label="Minimize Select Menu" class="min-max"  v-on:click="contactWindow" >?</button>
      <button v-if="compo" aria-label="Minimize Select Menu" class="min-max"  v-on:click="toggleSelectWindow" >MAP</button>
        <h1>{{ msg }}</h1>
        <p v-bind:class="{ expanded: isExpanded }">
          The maps here reflect the latest on file at the M. C. Tax Board.<br>
          Consult your local Tax Assessor to verify the map's currency.
        </p>
        <!-- <ESRIMap v-bind:class="{ expanded: isExpanded }"></ESRIMap> -->
        <component :is="compo" v-bind:class="{ expanded: isExpanded }"></component>
    <div id="styled-select">
      <!--  <label for="municipality">Municipality:</label> -->
      <select name="municipality" id="municipality" aria-label="Municipality" v-model="municipalID" v-on:change="changeMunicipality">
        <option  class="select-label">Municipality</option>
        <option v-for="option in municipalities" v-bind:key="option.ID" v-bind:value="option.ID">
          {{ option.val }}
        </option>
      </select>
      <!--     <label for="taxsheet">Tax Sheet:</label> -->
      <select name="taxsheet" id="taxsheet"  aria-label="Municipality" v-model="SheetName" v-on:change="changeTaxSheet(SheetName)">
          <option v-for="isheet in indexsheets" v-bind:key="isheet" v-bind:value="isheet" >
              {{ isheet }}
          </option>            
          <option v-for="sheet in detailsheets" v-bind:key="sheet" v-bind:value="sheet" >
              {{ 'Sheet ' + sheet }}
          </option>
      </select> 
        
    </div>
    <iframe title="hidden" id="fake" src="about:blank" width="0" height="0"></iframe>

    </div>
  
</template>

<script>
/* ///////stu commented this section out 12/27/2021
import router from '../router';
import * as lookup from '@/helpers/taxsheet';
*/
import ESRIMap from '@/components/ESRIMap.vue';
import {mapState,mapGetters,mapActions} from 'vuex'
export default {
  name: 'MapSelectOverlay',
  components: {
    ESRIMap
  },
  props: {
    msg: String
  },
  data () {
    return {
     isExpanded:false,
     compo: null
    

  
    
   //   municipalID:this.$store.state.municipalID,
   //   SheetName:this.$store.state.SheetName

    }
  },




 computed: {
   ...mapState(['municipalities','municipalID','SheetName','sheetlist']),
    ...mapGetters(['indexsheets','detailsheets']),
  SheetName: {
      get() {
        return this.$store.state.SheetName;
      },
      set(value) {
        this.$store.commit('updateSheetName', value);
      },
    },
  municipalID: {
      get() {
        return this.$store.state.municipalID;
      },
      set(value) {
        const ts = this.$store.state.sheetlist.filter(fld => fld.MunicipalID === value)[0].IndexSheets[0];
        const muni = value
        const ext = this.$store.state.municipalities.filter(fld => fld.ID === value)[0].extent;
       // alert(ext.xmin);
        this.$store.commit('updateextent', ext);
        this.$store.commit('updatetaxSheet', {ts,muni});

      },
    },
 
},
mounted() {
    this.compo = this.checkMobile() ? ESRIMap : null
   
    //  let muni = this.$route.params.muni;
    //  this.municipalID = muni
   //   let ts = this.$route.params.ts;
    
     //this.sheetlist = lookup['sheetlist'];
     //this.indexsheets = this.sheetlist.filter(fld => fld.MunicipalID === muni)[0].IndexSheets;
     //this.detailsheets = this.sheetlist.filter(fld => fld.MunicipalID === muni)[0].DetailSheets;
 
    var munidropdown = document.getElementById('municipality');
    for (var i = 0; i <  munidropdown.options.length; i++) {
        if ( munidropdown.options[i].text === this.municipalID) {
             munidropdown.selectedIndex = i;
            break;
        }
    }
  //  var tsdropdown = document.getElementById('taxsheet');
  //  for (var i = 0; i <  tsdropdown.options.length; i++) {
  //        console.log(tsdropdown.options[i].text + ', ' + ts)
  //      if ( tsdropdown.options[i].text === ts) {
  //           tsdropdown.selectedIndex = i;
  //          break;
  //      }
  //      else{
  //        tsdropdown.selectedIndex = 0;
  //      }
  //  }
  },


afterMount(){
    if (window.matchMedia('screen and (max-width: 700px)').matches) {
     this.isExpanded = false; 
    }

 },


methods:{
...mapActions(['updateCenter','updateExtent','updateZoom','updatetaxSheet']), 

   checkMobile: function() {
      return window ? window.innerWidth > 700 : true
    },
  toggleSelectWindow: function (event) {
      // `this` inside methods points to the Vue instance
     // alert('Hello ' + this.name + '!')
      // `event` is the native DOM event
      if (event) {
       // alert(event.target)
        this.isExpanded = !this.isExpanded
        if ( this.isExpanded === false) {location.reload(false)}
      }
     
      
    },
     contactWindow: function(){
       this.$modal.show('ContactUs');
     },

/* ///////stu commented this section out 12/27/2021
      changeTaxSheet(SheetName){
       // const m = this.municipalID;
       // const ts = SheetName;       
       // router.push({ path: `/municipalid/${m}/sheet/${ts}` }) 
   
     //   alert('changeTaxSheet: '  + SheetName);

    },
*/
    changeMunicipality()
      {
     //   const m = this.municipalID;
     //   this.indexsheets = this.sheetlist.filter(fld => fld.MunicipalID === m)[0].IndexSheets;
      //  this.detailsheets = this.sheetlist.filter(fld => fld.MunicipalID === m)[0].DetailSheets;
      //  let ts = this.indexsheets[0];
      
      //  router.push({ path: `/municipalid/${m}/sheet/${ts}` }) 
   
     //   alert('changeMunicipality: ' + m );

      },

    ShowTooltip(evt)
      {
        const tooltip = document.getElementById("info-box");
        tooltip.css('top',evt.pageY - tooltip.height()-30);
        tooltip.css('left',evt.pageX - tooltip.width()/2);
      },

    HideTooltip()
      {
        const tooltip = document.getElementById("info-box");
        tooltip.setAttributeNS(null,"visibility","hidden");
      }


}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#styled-select{
  margin: 0;
  padding:0;
}
#map-selector{
  position: relative;
  margin:0, 5px;
}
button.min-max{
  position: absolute;
  top:1px;
  right:1px;
  width:50px;
  z-index:4;
-webkit-appearance: button;
  -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  -webkit-padding-end: 20px;
  -webkit-padding-start: 2px;
  -webkit-user-select: none;
  user-select: none;
   border: 1px solid #AAA;
  color: #555;
  font-size: inherit;
  overflow: hidden;
  padding: 2px 3px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
  background-color: #779126;
  -webkit-border-radius: 1px;
  -moz-border-radius: 1px;
  border-radius: 1px;
  padding-left: 5px;
  display:inline-block;



}
#contact{
  position: absolute;
  top:3px;
  left:3px;
  width:24px;
  height:24px;
  z-index:4;
-webkit-border-radius: 12px;
  -moz-border-radius: 12px;
  border-radius: 12px;

}
#fake{
  z-index: 4;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    border: none;
}
h1{
  font-size: 1.0em;
  background: rgba(0, 0, 0, 0.904);
  padding:15px,0;
  margin:15px,0;
  height:25px;
  line-height: 25px;
  display:block;
}
p{
font-size: .75em;
background: rgba(0, 0, 0, 0.904);

line-height: 20px;

display:inline-block;
}
 .select-label{
   color: black;
   font-weight: 600;
   background: darkolivegreen;
    -webkit-user-select: none;  /* Chrome all / Safari all */
  -moz-user-select: none;     /* Firefox all */
  -ms-user-select: none;      /* IE 10+ */
  user-select: none;          /* Likely future */      


}
/* -------------------- Select Box Styles: stackoverflow.com Method */
/* -------------------- Source: http://stackoverflow.com/a/5809186 */
select#municipality,
select#taxsheet {
  -webkit-appearance: button;
  -webkit-box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  -webkit-padding-end: 20px;
  -webkit-padding-start: 2px;
  -webkit-user-select: none;
  user-select: none;
  background-image: url(http://i62.tinypic.com/15xvbd5.png), -webkit-linear-gradient(#779126, #97b343 40%, #bcd56e);
  background-position: 97% center;
  background-repeat: no-repeat;
  border: 1px solid #AAA;
  color: #555;
  font-size: inherit;
  margin: 5px 3px;
  overflow: hidden;
  padding: 5px 3px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f8f5f5;
 /* background-image: url("/img/15xvbd5.png"), -webkit-linear-gradient(#779126, #779126 40%, #779126); */
  background-color: #779126;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding-left: 5px;
  display:inline-block;
  z-index:4
}
select#municipality {
 width: 225px;
}

select#taxsheet {
 width: 125px;
}
option {
 padding:0;
 margin:0;
}

/* Option elements, when selected */
option:checked {
  background-color: #d3e4a1;
  color: red;
}

.expanded {
  display:none;
}

/* Media Queries
/* For smaller devices, switch to single column layout
/* ========================================*/ 
@media all and (max-width : 700px) {
  #styled-select{
    width:100vw;
    background: rgba(0, 0, 0, 0.815);
  }
  .desktoponly{
    display:none;
  }
}

</style>
